import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-qutation-list',
  templateUrl: './qutation-list.component.html',
  styleUrls: ['./qutation-list.component.css']
})
export class QutationListComponent implements OnInit {

  public menu_item_id = '14';
  public add_auth;
  public edit_auth;
  public del_auth;

  model = {
    'table_name': 'invoice', 'fromDate': new Date(), 'toDate': new Date(), 'qutation_no': '', 
    'customer_name': '', 'mobile': '', 'qutation_status': '0', 'branch_id': '0', 
    'title': 'قائمة التسعيرات'
  };

  statusList = [{ 'status_id': '0', 'status_name': 'الكل', 'status_name_en': 'All' },
    { 'status_id': '1', 'status_name': 'فعالة', 'status_name_en': 'Active' },
    { 'status_id': '2', 'status_name': 'منتهية', 'status_name_en': 'Expired' }];

  private dp = [];
  displayedColumns = ['qutation_no', 'qutation_date', 'expiry_date', 'customer_name', 'mobile', 'final_total',
    'qutation_type', 'qutation_status', 'invoice_no', 'view', 'print', 'export_invoice', 'copy', 'edit', 'del'];
  displayedColumns2 = ['qutation_no', 'qutation_date', 'expiry_date', 'customer_name', 'mobile', 'final_total',
    'qutation_type', 'qutation_status', 'invoice_no'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  branchList = [];
  from_date = '';
  to_date = '';
  From_Date; To_Date; Search_Msg;
  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService, private router: Router) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    }); 

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    }); 

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });
  }

  ngOnInit() {

    let href = this.router.url;
    let urlParts = href.split("/");
    if (urlParts[2] == '1') {
      this.menu_item_id = '14';
    }
    else if (urlParts[2] == '12') {
      this.menu_item_id = '81';
    }

    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    this.from_date = this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
      this.model['fromDate'].getDate() + ' 00:00:00';
    this.to_date = this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
      this.model['toDate'].getDate() + ' 23:59:59';

    if (this.menu_item_id == '81') {
      this.displayedColumns = ['qutation_no', 'qutation_date', 'customer_name', 'mobile', 'final_total',
        'maint_detail', 'view', 'print', 'export_invoice'];
      this.displayedColumns2 = ['qutation_no', 'qutation_date', 'customer_name', 'mobile', 'final_total', 'maint_detail'];
    }

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });
  }

  search() {
    this.dp = [];

    if ((this.model['fromDate'] == undefined || this.model['toDate'] == undefined) &&
      this.model['qutation_no'] == '') {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getQutationList' }; 
    if (this.menu_item_id == '81')
      obj['type'] = 'maint';

    if (this.model['qutation_no'] != '') {
      obj['qutation_no'] = this.model['qutation_no'];

      if (this.branchList.length == 2) 
        obj['branch_id'] = this.branchList[1]['branch_id'];
      else {
        let branch_list = [];
        this.branchList.forEach(element => {
          if (element.branch_id != '0')
            branch_list.push({ 'branch_id': element.branch_id });
        });
        obj['branch_list'] = branch_list;
      }
    }
    else {
      if (this.model['fromDate'] != undefined) {
        this.from_date = this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) +
          "-" + this.model['fromDate'].getDate() + ' 00:00:00';
        obj['from_date'] = this.from_date;
      }

      if (this.model['toDate'] != undefined) {
        this.to_date = this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) +
          "-" + this.model['toDate'].getDate() + ' 23:59:59';
        obj['to_date'] = this.to_date;
      }

      if (this.model['qutation_status'] != '0')
        obj['qutation_status'] = this.model['qutation_status'];

      if (this.model['customer_name'] != '')
        obj['customer_name'] = this.model['customer_name'];

      if (this.model['mobile'] != '')
        obj['mobile'] = this.model['mobile'];

      if (this.model['branch_id'] == '0') {
        if (this.branchList.length == 2) 
          obj['branch_id'] = this.branchList[1]['branch_id'];
        else {
          let branch_list = [];
          this.branchList.forEach(element => {
            if (element.branch_id != '0')
              branch_list.push({ 'branch_id': element.branch_id });
          });
          obj['branch_list'] = branch_list;
        }
      }
      else 
        obj['branch_id'] = this.model['branch_id'];
    }

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

    // this.from_date = this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
    //   this.model['fromDate'].getDate() + ' 00:00:00';
    // this.to_date = this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
    //   this.model['toDate'].getDate() + ' 23:59:59';

    // let condition = "`qutation_date` BETWEEN '" + this.from_date + "' AND '" + this.to_date + "' AND `status` != '0'";

    // if (this.model['branch_id'] != '0')
    //   condition += " AND `qutation`.`branch_id` = '" + this.model['branch_id'] + "'";

    // else if (this.model['branch_id'] == '0') {
    //   let index = 1;
    //   let list_length = this.branchList.length;

    //   condition += " AND `qutation`.`branch_id` IN (";
    //   this.branchList.forEach(element => {
    //     if (element.branch_id != '0') {
    //       if (index < list_length)
    //         condition += " '" + element.branch_id + "',";
    //       else if (index == list_length)
    //         condition += " '" + element.branch_id + "'";
    //     }
    //     index++;
    //   });
    //   condition += ")";
    // }

    // let query = "SELECT * FROM `qutation` WHERE " + condition;
    // let obj = { cmd: 'getList', query: query };

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.dp = data.data['list'];

    //     this.dp.forEach(element => {
    //       if (element.customer_no != '') {
    //         query = "SELECT `customer_name`, `mobile` FROM `customer` WHERE `acct_number` = '" + element.customer_no + "'";
    //         obj = { cmd: 'getList', query: query };

    //         this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //           .subscribe(data => {
    //             this.applicationConstants.appComp.hideBusyCursor();
    //             element.customer_name = data.data['list'][0]['customer_name'];
    //             element.mobile = data.data['list'][0]['mobile'];
    //           });
    //       }
    //       else
    //         element.mobile = '';

    //       element.qutation_date = (element.qutation_date).substring(0, 10);
    //       element.expiry_date = (element.expiry_date).substring(0, 10);
    //       element.final_total = ((Number(element.total) + Number(element.tax) - Number(element.discount))).toFixed(2);
    //       if (element.status == '1') {
    //         if (new Date() < new Date(element.expiry_date)) {
    //           element.qutation_status = 'فعالة';
    //           element.qutation_status_en = 'Active';
    //         }
    //         else {
    //           element.qutation_status = 'منتهية';
    //           element.qutation_status_en = 'Expired';
    //         }
    //       }
    //       else {
    //         element.qutation_status = 'ملغاة';
    //         element.qutation_status_en = 'Cancelled';
    //       }
    //       element.maint_detail = '';

    //       if (this.menu_item_id == '81') {
    //         let query = "SELECT `main_item_name_en` FROM `qutation_item`, `main_item`, `sub_item` WHERE " +
    //           "`qutation_item`.`qutation_no` = '" + element.qutation_no + "' AND `qutation_item`.`status` = '1'" +
    //           " AND `qutation_item`.`sub_item_number` = `sub_item`.`sub_item_number` AND `sub_item`.`main_item_id`" +
    //           " = `main_item`.`main_item_id`";

    //         let obj = { cmd: 'getList', query: query };

    //         this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //           .subscribe(data => {
    //             this.applicationConstants.appComp.hideBusyCursor();
    //             let qutation_item_list = data.data['list'];
    //             qutation_item_list.forEach(item => {
    //               element.maint_detail += item.main_item_name_en + ' - ';
    //             });
    //           });
    //       }
    //     });

    //     this.dataSource = new MatTableDataSource(this.dp);
    //     this.dataSource.sort = this.sort;
    //   });
  }

  // viewQutation(row) {
  //   this.applicationConstants.invoice_detail = { 'type':'qutation', 'no':row.qutation_no, 
  //     'page_title':'تفاصيل التسعيرة', 
  //     'button_list':[{ 'button_name':'عودة للقائمة', 'button_name_en':'Back To List', 'op_type':'back', 
  //       'router_link':'../qutation_list' }, 
  //     { 'button_name':'طباعة التسعيرة', 'button_name_en':' التسعيرة', 'op_type':'print', 'router_link':'' }, 
  //     { 'button_name':'تعديل التسعيرة', 'button_name_en':'تعديل التسعيرة', 'op_type':'print', 'router_link':'' }, 
  //     { 'button_name':'حذف التسعيرة', 'button_name_en':'حذف التسعيرة', 'op_type':'print', 'router_link':'' }, 
  //     { 'button_name':'تصدير الفاتورة', 'button_name_en':'تصدير الفاتورة', 'op_type':'print', 'router_link':'' }] };
  // }

  print(row = null) {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    if (row == null) {
      html_data = '<table cellpadding="8" cellspacing="0"><tr>';
      html_data += '<td width="33%"> ' + this.From_Date + ': ' + this.from_date + '</td>';
      html_data += '<td width="33%"> ' + this.To_Date + ': ' + this.to_date + '</td><td width="33%"></td></tr>';
      html_data += '</table>';

      let table = (document.getElementById('qutation_table2') as HTMLTableElement);
      html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
    }
    else {
      if (this.menu_item_id == '14')
        window.open(this.applicationConstants.generatePDF + "?type=qutation&no=" + row.qutation_no, "_blank");
      else if (this.menu_item_id == '81')  
        window.open(this.applicationConstants.generatePDF + "?type=qutation&is_maint=1&no=" + row.qutation_no, "_blank");
    }
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

  delQutation(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'qutation_no': row.qutation_no }];
      //console.log(values);
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          //console.log(data);
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

}
